/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Rating } from './rating';


export interface FeedbackResponseViewModel { 
    id: string;
    creatorId?: string;
    serviceProviderName?: string;
    serviceProviderEmailAddress?: string;
    rating1: Rating;
    rating2: Rating;
    rating3: Rating;
    rating4: Rating;
    rating5: Rating;
    comment?: string;
    dateCreated: Date;
}
